import { createContext, useContext, useReducer } from 'react';

const MapContext = createContext(null);

export const useMapContext = () => {
  const ctx = useContext(MapContext);
  if (!ctx) throw new Error('useMapContext doit être utilisé dans <MapProvider>');
  return ctx;
};

const initialState = {
  fetchAlert: false,
  alertMessage: '',
};

function reducer(state, action) {
  switch (action.type) {
    case 'PAGE_MAP_STATES_UPDATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export function MapProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { ...state, dispatch };

  return (
    <MapContext.Provider value={value}>
      {children}
    </MapContext.Provider>
  );
}
